import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../../shared/libs/auth/auth.service';
import { Router } from '@angular/router';
import { URLS_GUARD } from '../../../shared/libs/models/url-guard.enum';

@Component({
  standalone: false,
  selector: 'bt-login',
  templateUrl: './login.component.html',
  styleUrls: ['../shared/user-style.scss']
})
export class LoginComponent implements OnInit {
  readonly #authService = inject(AuthService);
  readonly #router = inject(Router);

  ngOnInit(): void {
    if (this.#authService.userLoggedValue) {
      const url = this.#authService.isCompany() ? URLS_GUARD.COMPANY : URLS_GUARD.PHOTOGRAPHER;
      this.#router.navigate([url]);
    }
  }

  goToLogin(): void {
    this.#authService.login();
  }

  requestCredentials(): void {

  }
}
